import { Injectable } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class VerifyService {
  changePasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'reset_password'}`;
  signUpVerifyOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'sign-up/verify-otp'}`;
  verifyOtp = `${AppSettings.EMAIL_API_ENDPOINT}/${'verify-2fa'}`;
  verifyToken: any;

  constructor(private readonly http: HttpClient) {}

  postPassword(data: any) {
    return this.http.post(this.changePasswordUrl, data);
  }


  dateTimeToHex(): any {
    const now = new Date();
    // Format: HHMMSSYYYYDDMM
    const pad = (n: number) => n.toString().padStart(2, '0');
    const randomSalt = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, '0');
    const milliseconds =
      now.getUTCMilliseconds().toString().padStart(3, '0') + '000';
    const customTime =
      pad(now.getUTCHours()) +
      pad(now.getUTCMinutes()) +
      pad(now.getUTCSeconds()) +
      milliseconds +
      now.getUTCFullYear().toString() +
      pad(now.getUTCDate()) +
      pad(now.getUTCMonth() + 1) +
      '.' +
      randomSalt; // Months are 0-based
    // Encode to hex using TextEncoder
    const encoder = new TextEncoder();
    const encoded = encoder.encode(customTime);
    const hexTimestamp = Array.from(encoded)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
    return hexTimestamp;
  }

  // in verify.service.ts
  verifyOtpFlow(email: string, otp: string) {
    return this.http.post(`${this.verifyOtp}`, { email, otp });
  }

  signupVerifyOtpLogin(email: string, otp: string) {
    return this.http.post(`${this.signUpVerifyOtp}`, {
      email,
      verify_otp: otp,
    });
  }
}
